<template>
   <div class="row">
      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="card">
          <div class="card-header text-center">Embed Objects</div>
          <div class="card-body">
              <router-link to="/embed-object">
                <img class="card-img-top" src="../assets/embedded.png" alt="Embedded Native Object" />
            </router-link>
        </div>
          <div class="card-footer text-muted">Embed any object from your Qvf with just the id (Visualization API)</div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="card">
          <div class="card-header text-center">Create Session Objects</div>
          <div class="card-body">
              <router-link to="/session-object">
                <img class="card-img-top" src="../assets/embedded.png" alt="Embedded Native Object" />
              </router-link>
            </div>
          <div class="card-footer text-muted">Create a session Object with custom definition (Visualization API)</div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="card">
          <div class="card-header text-center">Current Selections Toolbar</div>
          <div class="card-body">
              <router-link to="/current-selections">
                <img class="card-img-top" src="../assets/currentSelections.png" alt="Embedded Native Object" />
               </router-link>
            </div>
          <div class="card-footer text-muted">The Native Qlik Sense Selection Toolbar (Capability API)</div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="card">
          <div class="card-header text-center">Custom Selections Toolbar</div>
          <div class="card-body">
              <router-link to="/selection-toolbar">
              <img class="card-img-top" src="../assets/selectionToolbar.png" alt="Embedded Native Object" />
              </router-link>
              </div>
          <div class="card-footer text-muted">A Custom Selections Toolbar (Selection API)</div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="card">
          <div class="card-header text-center">Search</div>
          <div class="card-body">
              <router-link to="/search">
              <img class="card-img-top" src="../assets/search.png" alt="Search Fields" />
              </router-link>
              </div>
          <div class="card-footer text-muted">Search any Field or Dimension from your Qvf</div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="card">
          <div class="card-header text-center">Picasso Horizontal Barchart</div>
          <div class="card-body">
              <router-link to="/picasso-horizontal-barchart">
              <img class="card-img-top" src="../assets/picassoHorizontalBarchart.png" alt="Embedded Native Object" />
              </router-link>
              </div>
          <div class="card-footer text-muted">Custom Horizontal Barchart with Picasso.js & Enigma.js (Engine API)</div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="card">
          <div class="card-header text-center">Picasso Vertical Barchart</div>
          <div class="card-body">
              <router-link to="/picasso-vertical-barchart">
              <img class="card-img-top" src="../assets/picassoVerticalBarchart.png" alt="Embedded Native Object" />
              </router-link>
              </div>
          <div class="card-footer text-muted">Custom Vertical Barchart with Picasso.js & Enigma.js (Engine API)</div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="card">
          <div class="card-header text-center">Picasso Pie Chart</div>
          <div class="card-body">
              <router-link to="/picasso-pie-chart">
              <img class="card-img-top" src="../assets/picassoPie.png" alt="Embedded Native Object" />
              </router-link>
              </div>
          <div class="card-footer text-muted">Custom Pie Chart with Picasso.js & Enigma.js (Engine API)</div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="card">
          <div class="card-header text-center">Picasso Scatterplot</div>
          <div class="card-body">
              <router-link to="/picasso-scatterplot">
              <img class="card-img-top" src="../assets/picassoScotterplot.png" alt="Embedded Native Object" />
              </router-link>
              </div>
          <div class="card-footer text-muted">Scotterplot with Picasso.js & Enigma.js (Engine API)</div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="card">
          <div class="card-header text-center">Picasso Scatterplot - images</div>
          <div class="card-body">
              <router-link to="/picasso-scatterplot-with-images">
              <img class="card-img-top" src="../assets/picassoScotterplotImages.png" alt="Embedded Native Object" />
              </router-link>
              </div>
          <div class="card-footer text-muted">Scotterplot with custom images,  Picasso.js & Enigma.js (Engine API)</div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="card">
          <div class="card-header text-center">Picasso Line Chart</div>
          <div class="card-body">
              <router-link to="/picasso-line-chart">
              <img class="card-img-top" src="../assets/picassoLinechart.png" alt="Embedded Native Object" />
              </router-link>
              </div>
          <div class="card-footer text-muted">Custom Line Chart with Picasso.js & Enigma.js (Engine API)</div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="card">
          <div class="card-header text-center">Picasso Multi Line Chart</div>
          <div class="card-body">
              <router-link to="/picasso-multi-line-chart">
              <img class="card-img-top" src="../assets/picassoMultiLinechart.png" alt="Embedded Native Object" />
              </router-link>
              </div>
          <div class="card-footer text-muted">Custom Multi Line Chart with Picasso.js & Enigma.js (Engine API)</div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="card">
          <div class="card-header text-center">Picasso Combo Line Barchart</div>
          <div class="card-body">
              <router-link to="/picasso-combo-line-barchart">
              <img class="card-img-top" src="../assets/picassoCombochart.png" alt="Embedded Native Object" />
              </router-link>
              </div>
          <div class="card-footer text-muted">Scotterplot with Picasso.js & Enigma.js (Engine API)</div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-lg-3">
        <div class="card">
          <div class="card-header text-center">Picasso Stacked Barchart</div>
          <div class="card-body">
              <router-link to="/picasso-stacked-barchart">
              <img class="card-img-top" src="../assets/picassoStackedBarchart.png" alt="Embedded Native Object" />
              </router-link>
              </div>
          <div class="card-footer text-muted">Stacked barchart with Picasso.js & Enigma.js (Engine API)</div>
        </div>
      </div>

   </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style lang="less">
.card {
   position: relative;
   display: -ms-flexbox;
   display: flex;
   -ms-flex-direction: column;
   flex-direction: column;
   min-width: 0;
   word-wrap: break-word;
   background-color: #fff;
   background-clip: border-box;
   border: 1px solid rgba(0,0,0,.125);
   border-radius: .25rem;
   .card-body {
      -ms-flex: 1 1 auto;
      flex: 1 1 auto;
      padding: 1.25rem;
   }
   .card-img-top {
      width: 100%;
      border-top-left-radius: calc(.25rem - 1px);
      border-top-right-radius: calc(.25rem - 1px);
   }
   img {
      vertical-align: middle;
      border-style: none;
      width: 100%;
   }
   .card-header {
      font-weight: bold;
      padding: .75rem 1.25rem;
      margin-bottom: 0;
      background-color: rgba(0,0,0,.03);
      border-bottom: 1px solid rgba(0,0,0,.125);
   }
   .card-footer {
      padding: .75rem 1.25rem;
      background-color: rgba(0,0,0,.03);
      border-top: 1px solid rgba(0,0,0,.125);
   }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue